import { Box, Typography } from '@mui/material';
import { DISCLAMER_TEXT } from '@k-ucap/shared';

export const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: 1,
      px: 2,
      backgroundColor: 'background.paper',
      borderTop: '1px solid rgba(255,255,255,0.1)',
      textAlign: 'center',
    }}
  >
    <Typography variant="caption" color="text.secondary">
      {DISCLAMER_TEXT}
    </Typography>
  </Box>
);
